import { useEffect } from 'react'
import { Box, Paper, Typography } from '@material-ui/core'
import { babylistHealth } from 'lib/urls'
import { RegistryBannerEvents } from 'baby-ui/compounds/RegistryBanner/RegistryBannerEvents'
import { InfoButton } from 'components/buttons'
import css from './get-pump-through-insurance-cta.scss'

export type GetPumpThroughInsuranceCTAProps = RegistryBannerEvents

const GetPumpThroughInsuranceCTA = ({
  onView,
  onClick,
}: GetPumpThroughInsuranceCTAProps) => {
  useEffect(() => {
    onView?.()
  }, [])

  return (
    <Paper square className="mbm" variant="outlined">
      <Box pb={2} pt={1} px={2}>
        <Typography gutterBottom component="p" variant="h6">
          Let insurance pay for your pump!
        </Typography>
        <Typography component="p" variant="body2">
          Select an eligible breast pump from Babylist Health and insurance will
          cover up to 100% of the cost.
        </Typography>
      </Box>
      <InfoButton
        block
        newWindow
        className={css['btn-pump-insurance-cta']}
        color="secondary"
        href={babylistHealth}
        onClick={onClick}
      >
        Order through Insurance
      </InfoButton>
    </Paper>
  )
}

export default GetPumpThroughInsuranceCTA
